import defaultLogo from '../../assets/img/ic-img.svg';
import icHeartEmpty from '../../assets/img/ic-heart-empty.svg';
import icHeartFull from '../../assets/img/ic-heart-full.svg';
import formatDiscoveryUpdateDate from './formatDiscoveryUpdateDate';

const formatLocation = (company, hideCity) => {
    const parts = [company.country, !hideCity && company.cityRegion].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : 'n/a';
};

const formatCount = (value) => {
    if (value === null || value === undefined || value === '') return 'n/a';
    const count = Number(value);
    return Number.isFinite(count) && count >= 0 ? count : 'n/a';
};

const formatCompanySize = (company) => {
    const value = String(company.globalSize || company.localSize || '').trim();
    if (!value) return 'n/a';

    return value
        .replace(/employees?/gi, '')
        .replace(/\s*[-–—]\s*/g, '–')
        .replace(/\s{2,}/g, ' ')
        .trim() || 'n/a';
};

const formatRating = (value) => {
    const rating = Number(value);
    return Number.isFinite(rating) && rating > 0 ? rating.toFixed(1) : 'n/a';
};

const MobileDiscoveryCompanyCard = ({
    company,
    isFavorite = false,
    hideCity = false,
    onFavoriteToggle,
    onOpenCompany,
}) => {
    const opportunityStats = [
        { label: 'Jobs', value: formatCount(company.openJobsTotal) },
        { label: 'Internships', value: formatCount(company.openJobsIntern) },
        { label: 'Size', value: formatCompanySize(company), title: company.globalSize || company.localSize },
        { label: 'Rating', value: formatRating(company.googleRating) },
    ];

    const handleOpenCompany = () => {
        if (onOpenCompany) onOpenCompany(company);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOpenCompany();
        }
    };

    const handleFavoriteClick = (event) => {
        event.stopPropagation();
        if (onFavoriteToggle) onFavoriteToggle(company._id);
    };

    return (
        <article
            className="mobile-company-card"
            role="button"
            tabIndex={0}
            onClick={handleOpenCompany}
            onKeyDown={handleKeyDown}
        >
            <div className="mobile-company-card__body">
                <div className="mobile-company-card__top">
                    <div className="mobile-company-card__identity">
                        <div className="mobile-company-card__logo">
                            <img
                                src={company.logo || defaultLogo}
                                alt={company.title || 'Company logo'}
                            />
                        </div>

                        <div className="mobile-company-card__meta">
                            <h3 className="mobile-company-card__title mb-0">
                                {company.title || 'n/a'}
                            </h3>
                            <p className="mobile-company-card__location">
                                {formatLocation(company, hideCity)}
                            </p>
                            <p className="mobile-company-card__updated-at">
                                Updated at: {formatDiscoveryUpdateDate(company)}
                            </p>
                        </div>
                    </div>

                    <div className="mobile-company-card__actions mobile-company-card__actions--favorite-only">
                        <button
                            className={`mobile-company-card__favorite${isFavorite ? ' is-active' : ''}`}
                            type="button"
                            aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                            aria-pressed={isFavorite}
                            onClick={handleFavoriteClick}
                        >
                            <img
                                src={isFavorite ? icHeartFull : icHeartEmpty}
                                alt=""
                                aria-hidden="true"
                            />
                        </button>
                    </div>
                </div>
            </div>

            <div
                className="mobile-company-card__stats-strip mobile-company-card__stats-strip--four"
                aria-label="Company opportunities"
            >
                {opportunityStats.map((stat) => (
                    <div className="mobile-company-card__stat-cell" key={stat.label}>
                        <span className="mobile-company-card__stat-label">{stat.label}</span>
                        <span
                            className={`mobile-company-card__stat-value${stat.value === 'n/a' ? ' is-muted' : ''}`}
                            title={stat.title || undefined}
                        >
                            {stat.value}
                        </span>
                    </div>
                ))}
            </div>
        </article>
    );
};

export default MobileDiscoveryCompanyCard;
